import { useState, useEffect } from "react";
import axios from "axios";

export const useFonts = () => {
  const [fonts, setFonts] = useState([]);
  const [families, setFamilies] = useState([]);

  useEffect(() => {
    axios
      .get(
        "https://www.googleapis.com/webfonts/v1/webfonts?key=AIzaSyB0X6V4hLmYRbI1-Ruiqb5M0hasSz4c_Q4"
      )
      .then(({ data }) => {
        setFonts(data.items);
        setFamilies(data.items.map((font) => font.family));
      });
  }, []);

  return { fonts, families };
};
